<template>
    <v-app-bar
      light
      height="50px" 
      clipped-left
      class="header"
      elevation="0"
      rounded
      shrink-on-scroll
      scroll-target="#scrolling"
    >
      <!-- <v-app-bar-nav-icon @click.stop="draw" class="draw-aside-menu" color="#FFF"></v-app-bar-nav-icon> -->
      
      <!-- menu-hamburger -->
      <v-btn icon dark @click.stop="draw" class="icon-buger-mobile">
        <buger :active="activeBtn" />
      </v-btn>
      <div class="title">
        <slot />
      </div>
      <v-spacer />
      <div class="wrapper-right d-flex justify-right align-center">
        <div class="box-saldo">
          <v-skeleton-loader
            :loading="loadingBalance"
            :transition="'fade-transition'"
            type="text"
            width="80"
            height="20"
          >
            <span>{{ saldo | currency }}</span>
          </v-skeleton-loader>
        </div>
        <div class="icon-logout ml-2" @click="logaout()">
          <img src="@/assets/icons-aside/logout.svg" alt="">
        </div>
      </div>
    </v-app-bar>
</template>

<script>
import Events from '@/core/service/events'
import storage from '@/core/service/localStorage'
import { filter, orderBy } from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import config from '@/core/config'
import session from '@/core/service/session'
// import variables from '../../../assets/styles/helpers/_variables.scss'
// import VueCustomScrollbar from 'vue-custom-scrollbar'
// import buger from '@/views/components/burger'

export default {
  name: 'BrAppBar',
  components: {
    // VueCustomScrollbar: () => import('vue-custom-scrollbar'),
    buger: () => import('@/views/components/burger'),
    // Perfil: () => import('@/views/components/profile/index')
  },
  data: () => ({
    settings: {
      maxScrollbarLength: 60
    },
    activeFilter: null,
    activeBtn: false,
    rota: null,
    regiao: null,
  }),

  watch: {
    rota (val) {
      this.$router.push({ name: val })
    },

    regiao (val, old) {
      /* Caso trocou a regiao e está recarregando a pagina nao realizar o reload d novo */
      this.setLoadRegion(true)
      const atualRegion = session.get('regiaoAtual')
      
      /* primeiro carregamento */
      if (!old && val && (atualRegion === 'false' || !atualRegion)) {
        this.setLoadRegion(false)
        session.set('regiaoAtual', val)
        this.setValueRegiao(val)
        this.regiao = val
        return
      }

      /* setar atual apos o reload */
      if (val && atualRegion && val !== +atualRegion && !old) {
        this.loginUpdateRegiao(atualRegion).then(() => {
        this.setLoadRegion(false)
          session.set('regiaoAtual', +atualRegion)
          this.regiao = +atualRegion
          return this.setValueRegiao(+atualRegion)
        })
      }

      /* seta nova e faz reload */
      if (val && atualRegion && val !== +atualRegion && old) {
        this.loginUpdateRegiao(val).then(() => {
        this.setLoadRegion(false)
          if (window.location && old && old !== val) {
            session.set('regiaoAtual', val)
            return window.location.reload()
          }
        })
      }
      if(!session.get('regiaoAtual')){
        this.logaout()
      }
      this.setLoadRegion(false)
    },
    // user (val) {
    //   console.log('veio nessa merda')
    //   if (val && val.userRegionEntities &&  val.userRegionEntities[0]) this.regiao = val.userRegionEntities[0].id
    // },
  },
  mounted () {
    // console.log(session.get('regiaoAtual'))
    if (+session.get('regiaoAtual') ) {
      this.regiao = session.get('regiaoAtual')
    }else{
      this.$nextTick(() => {
        if (this.user.userRegionEntities) this.regiao = this.user.userRegionEntities[0].id
      })
    }
    
    this.getUser()
    this.getTermos()
    this.getEntitiesTypes()
    
    // Garante que o estado inicial seja correto
    this.activeBtn = false
    
    Events.$on('aside::alterDrawer', (e) => {
      this.activeBtn = e
    })
  },
  methods: {
    ...mapActions('auth', ['getUser', 'clearUser', 'setValueRegiao', 'loginUpdateRegiao']), 
    ...mapActions('termoConsentimento', ['getTermos']),
    ...mapActions('entities', ['getEntitiesTypes']),
    ...mapActions('users', ['getItens', 'getItenProfile']),
    ...mapActions(['setLoadRegion', 'getLoadRegion']),
    draw () {
      this.activeBtn = !this.activeBtn
      Events.$emit('appBar::drawer')
      Events.$emit('aside::alterDrawer', this.activeBtn)
    },
    
    scrollHanle(evt) {
      // eslint-disable-next-line no-console
      console.log(evt)
    },

    logaout () {
      storage.remove('auth-token')
      storage.remove('jwt')
      this.clearUser()
      this.$router.replace('/auth')
      location.reload(true)
    },

    abrirPerfil () {
      this.getItenProfile({ self: true, openProfile: true }).then( result => {
        Events.$emit('perfil::openModalPerfil', result.data.mapResult[0])
      }).catch(e => { console.log(e) })},

    ordernar (val) {
      let ordered = {}

      let orderByGestao = Object.keys(val).sort()
      orderByGestao = orderBy(orderByGestao, it => {
        if (it === 'gestao') return -1
        return 0
      })

      orderByGestao.forEach(function(key) {
        ordered[key] = val[key];
      })

      return ordered
    },
  },
  computed: {
    ...mapGetters('roles', {
      listaMenu: 'listAcl'
    }),
    ...mapGetters('auth', {
      user: 'user',
      idRegiao: 'getIdRegiao'
    }),
    ...mapGetters('users', ['listaMenu', 'listaMenuTratado']),
    ...mapGetters('termoConsentimento', ['termoAtual']),
    ...mapGetters('relatoriosGecom', ['typeGecom']),
    ...mapGetters('carteira', ['creditBalance', 'loadingBalance']),
    routes () {
      return  filter(this.$router.options.routes[0].children, item => {
        if (item.meta && item.meta.visible === true) return true
      })
    },

    listaMenuOrdenado () {
      return this.ordernar(this.listaMenuTratado)
    },

    avatar () {
      return this.user.jsonFlags.photoProfile ? `${config.urlAWS}/perfil/${this.user.jsonFlags.photoProfile}` : 'https://cdn.vuetifyjs.com/images/john.jpg'
    },

    exibirSelectRegiao () {
      return !(!this.typeGecom && this.$route.path === '/relatorios/gecom') 
    },

    saldo () {
      return this.creditBalance || 0
    }
  }
}
</script>

<style lang="scss">
  @import '../../../assets/styles/helpers/shareds';
  @import '../../../assets/styles/components/header';
  .header {
    width: 100%;
    // left: 50% !important;
    // transform: translateX(-50.5%) translateY(0px) !important;
    background-color: transparent !important;
    // margin-top: 10px !important;
    z-index: 99999;
    .logo {
      cursor: pointer;
    }
    &-menu{
      &-itens {
        .v-btn__content {
          text-transform: capitalize;
        }
      }
    }
    label {
      font-size: 14px;
      margin-right: 8px;
      color: #7C7C8A;;
    }
    .wrapper-avatar {
      position: relative;

      .icon-status {
        border: 2px solid #FFF;
        background-color: #F00;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        position: absolute;
        bottom: -3px;
        right: 3px;
      }
    }

    .v-text-field > .v-input__control > .v-input__slot::before, .v-text-field > .v-input__control > .v-input__slot::after {
      border-color: #7C7C8A !important;
    }

    .custon-badge {
      .v-badge__badge {
        font-size: 8px !important;
        height: 15px !important;
        width: 15px !important;
        min-width: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    
    .v-select__slot:hover {
      border-color: #F00;
    }

    .v-select__selection {
      color: #7C7C8A !important;
    }

    .v-input__slot {
      color: #FFF !important;
    }

    .username {
      font-size: .9rem;
      margin-right: 10px;
    }

    .select-region { 
      .v-input__slot { 
        margin-bottom: 0 !important; 
        color: #FFF;
      } 
    } 
  }

.box-saldo {
    width: 100%;
    border: 1px solid #373749;
    border-radius: 8px;
    padding: 5px 10px;
    span {
      color: $colorPrimary;
      font-family: Blinker;
      font-size: 16px;
      font-weight: 600;
      line-height: 19.2px;
      &:last-child {
        display: block;
        white-space: pre-wrap;
        color: $colorPrimary;
        font-family: Blinker;
        font-weight: 600;
        line-height: 19.2px;
      }
    }
  }

  .icon-logout {
    cursor: pointer;
  }
</style>